import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const HeaderSlimListUnibaSkeleton = () => {
    const topbarItems = [
        { type: 'dropdown', label: 'Servizi Online' },
        { type: 'link', label: 'Esse3' },
        { type: 'link', label: 'Rubrica' },
        { type: 'link', label: 'Webmail' },
        { type: 'link', label: 'App Uniba' },
        { type: 'dropdown', label: 'Info per' },
        { type: 'link', label: 'Cerca in uniba' },
    ];

    return (
        <ul
            className="uniba-topbar__list skeleton-topbar d-flex gap-3 px-3 py-2"
            role="menubar"
            aria-label="Navigazione principale"
        >
            {topbarItems.map((item, index) => (
                <li key={index} role="none" className="skeleton-topbar__item">
                    {item.type === 'dropdown' ? (
                        <div
                            className="ui dropdown d-flex align-items-center gap-2"
                            role="listbox"
                            aria-haspopup="true"
                            aria-expanded="false"
                            tabIndex={0}
                            aria-label={`Menu ${item.label}`}
                        >
                            <Skeleton width={100} height={16} />
                            <div className="dropdown-icon-skeleton bg-secondary rounded-circle" style={{ width: 12, height: 12 }} />
                        </div>
                    ) : (
                        <Skeleton width={90} height={16} />
                    )}
                </li>
            ))}
        </ul>
    );
};

export default HeaderSlimListUnibaSkeleton;
